import {combineReducers} from 'redux'
import auth from './authReducer.js'
import theme from './themeReducer.js'

export default combineReducers({
  auth,
  theme
})
